import Vue from 'vue'
import Router from 'vue-router'

import store from '@/store'

import routes from './routes'

Vue.use(Router)

const router = new Router({
  routes,
  mode:"history"
})

router.beforeEach((to, from, next) => {
  let requiredAuth = true
  to.matched.forEach(({meta}) => {
    if (typeof meta.requiredAuth === 'boolean') {
      requiredAuth = meta.requiredAuth
    }
  })
  if (requiredAuth && !store.getters.onSign) {
    return next({name: 'SignIn'})
  }
  return next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js